import React, { useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import Alert from "@mui/material/Alert";
import queryString from "query-string";
import { LoginActions } from "@Pages";
import { useNavigate } from "react-router-dom";

import "./style.scss";

type FormData = {
    confirmpassword: string;
    password: string;
    token: string;
    userId: string;
};

export const RenewPasswordForm = () => {
    const params = queryString.parse(window.location.search);
    const token = params.ri; //recovery id
    const userId = params.ui;
    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        watch,
        clearErrors,
    } = useForm<FormData>();
    const dispatch = useDispatch<any>();

    const password = useRef({});
    password.current = watch("password", "");

    const onSubmit = async ({ password, confirmpassword }: FormData) => {
        try {
            dispatch(
                LoginActions.PostRenewAccount({
                    password,
                    userId,
                    token,
                })
            );
        } catch (error) {
            console.error(error);
        } finally {
            reset();
            homeRedirection();
        }
    };
    const homeRedirection = () => navigate("/");

    useEffect(() => {
        if (!userId && !token) homeRedirection();
    });

    return (
        <form
            className="ForgotPasswordForm"
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit(onSubmit)}
        >
            {(errors.password || errors.confirmpassword) && (
                <div>
                    <Alert severity="error" variant="filled">
                        {errors?.password
                            ? errors?.password?.message
                            : errors?.confirmpassword?.message}
                        {}
                    </Alert>
                </div>
            )}
            <input
                type="password"
                className="LoginForm__input"
                placeholder="Password"
                autoComplete="current-password"
                {...register("password", {
                    required: { value: true, message: "password is required" },
                    pattern: {
                        value: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9_@./#&+-]{6,}$/,
                        message:
                            "Passwords must have at least one letter and one number",
                    },
                    minLength: {
                        value: 6,
                        message:
                            "Passwords must be at least 6 characters in length",
                    },
                })}
            />
            <input
                type="password"
                defaultValue=""
                className="LoginForm__input"
                placeholder="Confirm Password"
                autoComplete="current-password"
                {...register("confirmpassword", {
                    validate: (value) =>
                        value === password.current ||
                        "The passwords do not match",
                })}
            />
            <button
                type="submit"
                className="ButtonReset ButtonReset-blue"
                onClick={() => clearErrors()}
            >
                Send
            </button>
        </form>
    );
};

export default RenewPasswordForm;
